import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useBlocker, useBeforeUnload } from 'react-router-dom';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
export const useWithPrompt = (submit) => {
    const [isPrompt, setIsPrompt] = useState(false);
    const onSave = useRef();
    console.log('dddddd', isPrompt);
    const blocker = useBlocker(isPrompt);
    useEffect(() => {
        if (blocker.state === "blocked") {
            Modal.confirm({
                title: '即将离开当前页面，是否保存本次修改内容？',
                icon: _jsx(ExclamationCircleOutlined, {}),
                okText: '保存',
                cancelText: '放弃',
                onOk() {
                    submit && submit();
                    onSave.current && onSave.current();
                },
                onCancel() {
                    blocker.proceed?.();
                },
            });
        }
    }, [blocker]);
    useBeforeUnload(useCallback((event) => {
        if (isPrompt) {
            event.preventDefault();
            event.returnValue = "";
        }
    }, [isPrompt]), { capture: true });
    return {
        setIsPrompt,
        onSave: (fn) => { onSave.current = fn; }
    };
};
